export const environment = {
    production: true,
    SERVER_API_URL: '',
    VERSION: '1.0.0',
    ITEMS_PER_PAGE: 10,
    LANGUAGES: ['fr', 'en'],
    landingPagePreviewBaseUrl: '/landingpage',
    personalBaseUrl: '/personal',
    URL_ENGINE: 'https://engines.airiane.com',
    URL_DMP: 'https://ui.dmp.preprod.travel-juice.net/',
    KeycloakUrl: 'https://keycloak.dmp.preprod.travel-juice.net/auth/',
    KeycloakRealm: 'jhipster',
    KeycloakClientId: 'web_app'
};
